import { EntityModel } from '@/interfaces'
import {
  ALL_TEXT_WITH_ICON_BLOCKS_QUERY,
  CREATE_TEXT_WITH_ICON_BLOCK_MUTATION,
  DELETE_TEXT_WITH_ICON_BLOCK_MUTATION,
  FORCE_DELETE_TEXT_WITH_ICON_BLOCK_MUTATION,
  SINGLE_TEXT_WITH_ICON_BLOCK_QUERY,
  UPDATE_TEXT_WITH_ICON_BLOCK_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const cmsTextWithIconBlockModel: EntityModel = {
  name: 'textWithIconBlock',
  namePlural: 'textWithIconBlocks',
  uniqueName: 'cmsTextWithIconBlock',
  uniqueNamePlural: 'cmsTextWithIconBlocks',
  path: 'cms/blocks/text_with_icon_block',
  baseUrl: '/cms/blocks/text_with_icon_blocks',
  translationPrefix: 'entities:cmsTextWithIconBlock.',
  getDisplayName: (values: any) => {
    return 'Text with icon'
  },
  gql: {
    getAll: ALL_TEXT_WITH_ICON_BLOCKS_QUERY,
    getSingle: SINGLE_TEXT_WITH_ICON_BLOCK_QUERY,
    create: CREATE_TEXT_WITH_ICON_BLOCK_MUTATION,
    update: UPDATE_TEXT_WITH_ICON_BLOCK_MUTATION,
    delete: DELETE_TEXT_WITH_ICON_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_TEXT_WITH_ICON_BLOCK_MUTATION,
  },
  attributes: {
    title: {
      name: 'title',
      label: 'entities:cmsTextWithIconBlock.attributes.title.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    text: {
      name: 'text',
      label: 'entities:cmsTextWithIconBlock.attributes.text.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    image: {
      name: 'image',
      label: 'entities:cmsTextWithIconBlock.attributes.image.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    imagePosition: {
      name: 'imagePosition',
      label: 'entities:cmsTextWithIconBlock.attributes.imagePosition.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsTextWithIconBlock.attributes.imagePosition.selectOptions.left.label',
          value: 'left',
        },
        {
          label: 'entities:cmsTextWithIconBlock.attributes.imagePosition.selectOptions.right.label',
          value: 'right',
        },
      ],
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsTextWithIconBlockModel
